const state = {
  balance: 0,
  minAvailableBalance: 0,
  showAvailableBalance: false,
  committedBalance: 0,
}

const getters = {
  balance: (state) => state.balance,
  minAvailableBalance: (state) => state.minAvailableBalance,
  showAvailableBalance: (state) => state.showAvailableBalance,
  committedBalance: (state) => state.committedBalance,
}

const actions = {
  showAvailableBalance({ commit }) {
    state.balance < state.minAvailableBalance
      ? commit('setShowAvailableBalance', true)
      : commit('setShowAvailableBalance', false)
  },
}

const mutations = {
  setBalance: (state, balance) => {
    state.balance = balance
  },
  
  setCommittedBalance: (state, committedBalance) => {
    state.committedBalance = committedBalance
  },

  setMinAvailableBalance: (state, minAvailableBalance) => {
    state.minAvailableBalance = minAvailableBalance
  },

  setShowAvailableBalance: (state, showAvailableBalance) => {
    state.showAvailableBalance = showAvailableBalance
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
